import React from "react";
import './header.css';

const Header = (props) => 
 <div className="container" style={props.styleCss} > 
     <h2>La couleur, tu choisiras. La magie s'opérera.</h2>
</div>;

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js